module.exports = __webpack_public_path__ + "img/Personal.02818017.svg";